import { render } from "./EditPlan.vue?vue&type=template&id=f1e43da6"
import script from "./EditPlan.vue?vue&type=script&lang=js"
export * from "./EditPlan.vue?vue&type=script&lang=js"
script.render = render

export default script